import React from 'react';
import Avatar from '@mui/material/Avatar';
import './OrderListTable.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';


import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import AlertDialog from '../Modals/AlertDialog';

import dayjs from 'dayjs';

import {
    Select,
    MenuItem,
    Card,
    CardContent,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
    NativeSelect,
     Fab
}
    from '@mui/material/'
import Image from 'mui-image';


function OrderListTable(props) {
    var utc = require('dayjs/plugin/utc')
    dayjs.extend(utc)

    const [selectedRow, setSelectedRow] = React.useState(-1);
    const [editingActualCansAndBottles, setEditingActualCansAndBottles] = React.useState(false);
    const [actualCansAndBottles, setActualCansAndBottles] = React.useState(0);
    const [selectedDateFilter, setSelectedDateFilter] = React.useState('ALL');
    const [sortColumn, setSortColumn] = React.useState(props.Section == 'Paid' ? 'Date' : props.Section == 'Completed' ? 'Date' : props.Section == 'Available' ? 'AvailableDate' : 'ScheduledDate');
    const [sortDirectionAsc, setSortDirectionAsc] = React.useState(false);
    const [orders, setOrders] = React.useState(props.Orders);
    const [summaryTotalPickup, setSummaryTotalPickup] = React.useState(0);
    const [summaryEstimatedProfit, setSummaryEstimatedProfit] = React.useState(0);
    const [summaryTotalQuantity, setSummaryTotalQuantity] = React.useState(0);
    const [summaryActualProfit, setSummaryActualProfit] = React.useState(0);
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });


    const [alertDialog, setAlertDialog] = React.useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    React.useEffect(() => {
        calculateSummaryTotals(props.Orders,null); // only called once
    }, []);


    const handleRowClick = (e, order) => {
        if (order.RequestID == selectedRow) {
            // same row clicked again
            setSelectedRow(0);
        }
        else {
            setSelectedRow(order.RequestID);
        }
        setEditingActualCansAndBottles(false);
        setActualCansAndBottles(0);
    }


    function buildPaidPickupsSummaryArea() {
        return (
            <div className={'SummaryArea'} style={{display:'flex', justifyContent:'center'} }>
            <Card  style={{ marginBottom: '10px', backgroundColor: 'var(--sipzee-yellow-3)' }}>
                <CardContent>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ width: '130px', display: 'flex', marginRight: '3px', justifyContent: 'center' }}>
                            <MobileView>
                                <NativeSelect value={selectedDateFilter}

                                    onChange={handleDateFilterChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'uncontrolled-native',
                                    }}>
                                    <option value='ALL'>All Time</option>
                                    <option value='This Week'>This Week</option>
                                    <option value='Last Week'>Last Week</option>
                                    <option value='This Month'>This Month</option>
                                    <option value='Last Month'>Last Month</option>
                                    <option value='This Year'>This Year</option>
                                    <option value='Last Year'>Last Year</option>
                                </NativeSelect>
                            </MobileView>
                            <BrowserView>

                                <Select variant="filled"

                                    value={selectedDateFilter}
                                    onChange={handleDateFilterChange}
                                    inputProps={{
                                        name: 'age',
                                        id: 'uncontrolled-native',
                                    }}>
                                    <MenuItem value='ALL'>All Time</MenuItem>
                                    <MenuItem value='This Week'>This Week</MenuItem>
                                    <MenuItem value='Last Week'>Last Week</MenuItem>
                                    <MenuItem value='This Month'>This Month</MenuItem>
                                    <MenuItem value='Last Month'>Last Month</MenuItem>
                                    <MenuItem value='This Year'>This Year</MenuItem>
                                    <MenuItem value='Last Year'>Last Year</MenuItem>
                                </Select>
                            </BrowserView>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Pickups</Typography></div>
                            <div>{summaryTotalPickup}</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Quantity</Typography></div>
                            <div>{summaryTotalQuantity}</div>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', alignSelf: 'stretch', justifyContent: 'space-between' }}>
                            <div><Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Payout</Typography></div>
                            <div>{(isNaN(summaryActualProfit) ? <span style={{ fontSize: '8pt' }}> {summaryActualProfit}</span> : formatter.format(summaryActualProfit))}</div>
                        </div>

                    </div>
                    <div style={{ display: 'flex', marginTop:'10px' }}>
                        {orders.length === 0 ?
                            null
                            :
                            <Fab size='small' onClick={handleExcelFileDownload}>
                                <>
                                    <Image src="images/excel.svg" height={25} width={25} />
                                    <DownloadIcon style={{ position: 'absolute', height: '15px', width: '15px', left: '20px', top: '20px', color: 'var(--sipzee-yellow)' }} />
                                </>
                            </Fab>
                        }
                    </div>
                </CardContent>
                </Card>
            </div>
        )
    }

    function handleExcelFileDownload() {
        var data = [];

        for (let i = 0; i < orders.length; i++) {
            let quantity = 0;
            if (orders[i].BottleSlipTotalQuantity > 0) {
                quantity = parseInt(orders[i].BottleSlipTotalQuantity);
            }
            else {
                quantity = parseInt(orders[i].Quantity_Of_Cans_Bottles);
            }

            data.push(
                {
                    'Pickup Date': new Date(orders[i].PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' }) + " " + new Date(orders[i].PickupTimestamp.Data).toLocaleString('en-US', { timeStyle: 'short' }),
                    'Quantity': quantity,
                    'Payout': formatter.format(orders[i].FinalPayoutToClient).replace('$', ''),
                    'Payment': formatPaymentMethod(orders[i])
                }
            )
        }

        const worksheet = XLSX.utils.json_to_sheet(data);

        // (C2) CREATE NEW EXCEL "FILE"
        var workbook = XLSX.utils.book_new();
        workbook.SheetNames.push("Orders");
        workbook.Sheets["Orders"] = worksheet;

        worksheet["!cols"] = [{ wch: 20 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 10 }]; // set column A width to 10 characters

        // (C3) "FORCE DOWNLOAD" XLSX FILE
        XLSX.writeFile(workbook, "Completed Orders.xlsx");
    }

    function calculateEstimatedProfit(order) {
        let tipAmount = parseFloat(order.TipAmount);
        let estProfit = (order.Quantity_Of_Cans_Bottles * 0.1 * .4 + tipAmount);
        return estProfit;
    }

    function filterAndSort(column, directionAsc, dateFilterValue) {
       // let sortedOrders = [...orders];
        let today = new Date();

        let prevMonday = new Date();
        prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);

        let prevMonday2 = new Date();
        prevMonday2.setDate(prevMonday.getDate() - 7);

        let beginningOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        let beginningOfPrevMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        beginningOfPrevMonth.setMonth(beginningOfPrevMonth.getMonth() - 1);

        let beginningOfYear = new Date(today.getFullYear(), 0, 1);
        let beginningOfPrevYear = new Date(today.getFullYear() - 1, 0, 1);
        // filter first
        let tempOrders = [];
        for (let i = 0; i < props.Orders.length; i++) {
            if (dateFilterValue === 'ALL') {
                tempOrders.push(props.Orders[i]);
            }
            else if (dateFilterValue === 'This Week') {
                //prevMonday to today
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > today.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
        
            }
            else if (dateFilterValue === 'Last Week') {
                //prevMonday2 to prevMonday
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > prevMonday2.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < prevMonday.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
                
            }
            else if (dateFilterValue === 'This Month') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfMonth.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'Last Month') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfPrevMonth.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < beginningOfMonth.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'This Year') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfYear.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            else if (dateFilterValue === 'Last Year') {
                if (new Date(props.Orders[i].PickupTimestamp.Data).getTime() > beginningOfPrevYear.getTime() &&
                    new Date(props.Orders[i].PickupTimestamp.Data).getTime() < beginningOfYear.getTime()) {
                    tempOrders.push(props.Orders[i]);
                }
            }
            
        }

        // calculate summary totals
        calculateSummaryTotals(tempOrders, dateFilterValue);

        if (column == 'PickupDate') {
            tempOrders.sort(pickupDateSorter);
        }
        else if (column == 'Scheduled Pickup Date')
        {
            tempOrders.sort(scheduledPickupDateSorter);
        }
        else if (column == 'Quantity') {
            tempOrders.sort(quantitySorter);

        }
        else if (column == 'Estimated Profit') {
            tempOrders.sort(estimatedProfitSorter);
        }
        else if (column == 'Actual Profit') {
            tempOrders.sort(actualProfitSorter);
        }
        else if (column == 'Status') {
            tempOrders.sort(dynamicSort('Status_Reason'));
        }
        else if (column == 'City') {
            tempOrders.sort(dynamicSort('CustomerAddress_City'));
        }
        else if (column == 'Returner') {
            tempOrders.sort(dynamicSort('Owner_FirstName'));
        }
        else if (column == 'CustomerName') {
            tempOrders.sort(dynamicSort('CustomerName'));
        }
        else if (column == 'Final Payment') {
            tempOrders.sort(finalPayoutSorter);
        }

        if (!directionAsc) {
            tempOrders.reverse();
        }

        setOrders(tempOrders);
    }

    function calculateSummaryTotals(orderList, dateFilter) {
        if (orderList == null) {
            return;
        }
        let totalPickup = 0;
        let totalEstimatedProfit = 0;
        let totalActualProfit = 0;
        let totalQuantity = 0;
        let allActualProfitEntered = true;
        totalPickup = orderList.length;
        for (let i = 0; i < orderList.length; i++) {
            totalEstimatedProfit += calculateEstimatedProfit(orderList[i]);
            totalActualProfit += orderList[i].FinalPayoutToClient;
            if (orderList[i].BottleSlipTotalQuantity > 0) {
                totalQuantity += parseInt(orderList[i].BottleSlipTotalQuantity);
            }
            else {
                totalQuantity += parseInt(orderList[i].Quantity_Of_Cans_Bottles);
            }

           
            if (orderList[i].ActualProfit == 0) {
                allActualProfitEntered = false;
            }
        }
        setSummaryTotalQuantity(totalQuantity);
        setSummaryTotalPickup(totalPickup);
        setSummaryEstimatedProfit(totalEstimatedProfit);
        setSummaryActualProfit(totalActualProfit);
      
    }

    function handleDateFilterChange(e) {
        setSelectedDateFilter(e.target.value);
        filterAndSort(sortColumn, sortDirectionAsc, e.target.value);
    }

    function sortingChanged(column) {
        let directionAsc;
        if (sortColumn == column) {
            setSortDirectionAsc(!sortDirectionAsc);
            directionAsc = !sortDirectionAsc;
        }
        else {
            setSortColumn(column);
            setSortDirectionAsc(true);
            directionAsc = true;
        }

        // redo the sorting:
        filterAndSort(column, directionAsc, selectedDateFilter);
    }

    //#region Sorters

    function pickupDateSorter(a, b) {
        return new Date(a.PickupTimestamp.Data).getTime() - new Date(b.PickupTimestamp.Data).getTime();
    }

    function scheduledPickupDateSorter(a, b) {
        return new Date(a.ScheduledPickUpDate).getTime() - new Date(b.ScheduledPickUpDate).getTime();
    }

    function quantitySorter(a, b) {
        return parseInt(a.Quantity_Of_Cans_Bottles) - parseInt(b.Quantity_Of_Cans_Bottles);
    }

    function estimatedProfitSorter(a, b) {
        return calculateEstimatedProfit(a) - calculateEstimatedProfit(b);
    }

    function actualProfitSorter(a, b) {
        return (a.ActualProfit == undefined ? 0 : parseFloat(a.ActualProfit)) - (b.ActualProfit == undefined ? 0 : parseFloat(b.ActualProfit))
    }

    function finalPayoutSorter(a, b) {
        return (a.FinalPayoutToClient == undefined ? 0 : parseFloat(a.FinalPayoutToClient)) - (b.FinalPayoutToClient == undefined ? 0 : parseFloat(b.FinalPayoutToClient))
    }

    function dynamicSort(property) {
        return function (a, b) {
            return (a[property].trim().toLowerCase() < b[property].trim().toLowerCase()) ? -1 : (a[property].trim().toLowerCase() > b[property].trim().toLowerCase()) ? 1 : 0;
        }
    }

    //#endregion
       
    //#region Completed Orders section

    

    function buildPaidOrderHeader() {
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px' }}>
            <div style={{ width: '70px', display: 'flex' }} onClick={(e) => sortingChanged('PickupDate')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Date</Typography>
                {sortColumn == 'PickupDate' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'PickupDateDate' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Quantity')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Quantity</Typography>
                {sortColumn == 'Quantity' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Quantity' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Final Payment')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Payout</Typography>
                {sortColumn == 'Final Payment' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Final Payment' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ width: '80px', display: 'flex' }} onClick={(e) => sortingChanged('Actual Profit')}>
                <Typography sx={{ fontSize: '10pt', fontWeight: 'bold' }}>Payment</Typography>
                {sortColumn == 'Actual Profit' && sortDirectionAsc ?
                    <KeyboardArrowDownIcon />
                    : null
                }
                {sortColumn == 'Actual Profit' && !sortDirectionAsc ?
                    <KeyboardArrowUpIcon />
                    : null
                }
            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

   
    function buildPaidOrderRow(order) {
        let quantity = 0;
        if (order.BottleSlipTotalQuantity > 0) {
            quantity = parseInt(order.BottleSlipTotalQuantity);
        }
        else {
            quantity = parseInt(order.Quantity_Of_Cans_Bottles);
        }
        return (<div style={{ display: 'flex', width: '100%', minHeight: '30px', fontSize: '10pt' }}>
            <div style={{ width: '70px' }}>
                {new Date(order.PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' })}
            </div>
            <div style={{ width: '80px' }}>
                {quantity}
            </div>
            <div style={{ width: '80px' }}>
                {formatter.format(order.FinalPayoutToClient)}
            </div>
            <div style={{ width: '80px' }}>
                {formatPaymentMethod(order)}


            </div>
            <div style={{ flexGrow: 1 }}></div>
        </div>);
    }

    function formatPaymentMethod(pickupRequest) {
        try {
            if (pickupRequest.CustomerPaymentMethod.indexOf('DONATE') > -1) {
                if (pickupRequest.Donation === null) {
                    return 'Donated';
                }
                return 'Donated to ' + pickupRequest.Donation.CompanyName;
            }
            else if (pickupRequest.CustomerPaymentMethod == 'TipAll') {
                return 'Tip All';
            }
            else {
                return pickupRequest.CustomerPaymentMethod;
            }
        }
        catch {
            return pickupRequest.CustomerPaymentMethod;
        }
           
    }

   

    function buildPaidOrderExpansionArea(pickupRequest) {
        let paymentStatusInfo = null;
        if (pickupRequest.PaymentInfo != '' && typeof pickupRequest.PaymentInfo === 'string') {
            pickupRequest.PaymentInfo = JSON.parse(pickupRequest.PaymentInfo);
        }

        /*
         *   1	Pending Release	Payment has been confirmed/submitted but hasn�t made it through the scrubbing/screening we do on our end.
             2	Released	Payment has been scrubbed and made it through our screening process and is ready to be processed.
             3	Processing	Only used by printed checks, when a check is processing it means it is being printed and mailed.
             4	Sent	Printed checks are in the mail, digital checks have been emailed, ACHs have been sent through the bank.
             5	Posted / Cashed	When available it means a check has been cashed and cleared by the recipient.
             6	Returned	When we are processing returns for you and a printed check has been returned to us.
             7	Cancelled	Payment was cancelled before being processed/sent.
             8	Reissued	When a payment gets resent for whatever reason, another payment record is created and the original is marked as being reissued.
        */
        if (pickupRequest.PaymentInfo.needs_repaired == '1') {
            paymentStatusInfo = <div>Needs Repair</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '1') {
            paymentStatusInfo = <div>Pending Release</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '2') {
            paymentStatusInfo = <div>Released</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '3') {
            paymentStatusInfo = <div>Processing</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '4') {
            paymentStatusInfo = <div>Sent on {dayjs(pickupRequest.PaymentInfo.sent_ts).format('MM/DD/YY')}</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '5') {
            paymentStatusInfo = <div>Cashed</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '6') {
            paymentStatusInfo = <div>Returned</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '7') {
            paymentStatusInfo = <div>Cancelled</div>;
        }
        else if (pickupRequest.PaymentInfo.status_id == '8') {
            paymentStatusInfo = <div>Reissued</div>;
        }

        let quantity = 0;
        if (pickupRequest.BottleSlipTotalQuantity > 0) {
            quantity = parseInt(pickupRequest.BottleSlipTotalQuantity);
        }
        else {
            quantity = parseInt(pickupRequest.Quantity_Of_Cans_Bottles);
        }

            return (
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', padding: '3px' }}>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Picked up on: </div><div>{new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { weekday: 'short' })} {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { dateStyle: 'short' })} at {new Date(pickupRequest.PickupTimestamp.Data).toLocaleString('en-US', { timeStyle: 'short' })}</div></div>
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'space-between', width: '100%', minHeight: '35px' }}><div>Estimated Bottles & Cans:</div><div>{quantity}</div></div>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>
                    <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Payout:</div>
                    <div style={{ alignSelf: 'center' }}>{formatter.format(pickupRequest.FinalPayoutToClient)}</div>
                </div>
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>
                    <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Payment:</div>
                    <div style={{ alignSelf: 'center' }}>{formatPaymentMethod(pickupRequest)}</div>
                </div>
                    <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>
                        <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Payment Status:</div>
                        <div style={{ alignSelf: 'center' }}> {paymentStatusInfo}</div>
                    </div>

                   
                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-end', alignContent: 'center', width: '100%', minHeight: '30px' }}>
                    <div style={{ marginRight: 'auto', alignSelf: 'center' }}>Recycler:</div>
                    <div style={{ alignSelf: 'center' }}>
                        <Avatar
                            alt="Photo"
                                src={(pickupRequest.Owner_ImagePath.indexOf('sipzeephotos.blob.core') > -1 ? pickupRequest.Owner_ImagePath : 'https://sipzee.com/Returner/ReturnerProfilePics/' + pickupRequest.Owner_ImagePath)}
                            sx={{ width: 55, height: 55, alignSelf: 'center' }}
                            />
                            <div>{pickupRequest.Owner_FirstName}</div>
                    </div>
                </div>
                
            </div>)
    }

    //#endregion
  



    function getAvatar(item) {
        if (item.ChangeBy === 'Admin') {
            return 'images/SipzeeAvatar.png';
        }
        else if (item.ChangeBy == 'Recycler') {
            if (item.Avatar.toUpperCase().indexOf('HTTPS://') > -1) {
                return item.Avatar;
            }
            else {
                if (window.location.href.indexOf('localhost') > -1) {
                    return 'https://sipzee.com' + item.Avatar;
                }
                else if (window.location.href.indexOf('test.sipzee.com') > -1) {
                    return 'https://test.sipzee.com' + item.Avatar;
                }
                else {
                    return 'https://sipzee.com' + item.Avatar;
                }

            }
        }
        else {
            return 'images/CustomerChatAvatar.png';
        }
    }

   
 

    return (

        <>

            {
                props.Section === 'Completed' ? buildCompletedPickupsSummaryArea() : ''
            }
            {
                props.Section === 'Paid' ? buildPaidPickupsSummaryArea() : ''
            }

            <div style={{ width: '100%', maxWidth:'500px', minWidth:'330px', marginLeft:'auto', marginRight:'auto' }}>
                <Card className='OrderListHeader' style={{backgroundColor:'var(--sipzee-gray-2)', color:'white'} }>
                   
                    {props.Section === 'Paid' ? buildPaidOrderHeader() : null}
                  
                   
                </Card>
                {

                    orders.map((order, index) => {
                        return <Accordion key={'OrderItem_' + order.RequestID} expanded={selectedRow === order.RequestID} onChange={(e) => handleRowClick(e, order)}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                className={(selectedRow === order.RequestID ? 'ExpandableRow-Selected ' : ' ') + (index % 2 == 0 ? 'AccordionAlternate ' : ' ')}

                            >
                               
                                {props.Section === 'Paid' ? buildPaidOrderRow(order) : null}
                              
                            </AccordionSummary>
                            <AccordionDetails>
                               
                                {props.Section === 'Paid' ? buildPaidOrderExpansionArea(order) : null}
                                
                            </AccordionDetails>
                        </Accordion>
                    })
                }

              
                <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />
            </div>
        </>
    );
}

export default OrderListTable;



